// frontend/src/components/profile-components/DailyMessageBanner.js

import React, { useState, useEffect } from 'react'; 
import { Link } from 'react-router-dom'; 
import { MessageSquare, AlertTriangle, Loader2 } from 'lucide-react';

// 🛑 مسیرهای ایمپورت اصلاح شدند
import { getDailyMessage } from '../../services/profileService'; 
import { getCurrentPersianDate as getPersianDate } from '../../utils/dateUtils'; 

// ----------------------------------------------------------------------
// 🛑 تابع محلی getPersianDate حذف شد (چون از utils ایمپورت شد)
// ----------------------------------------------------------------------

export function DailyMessageBanner() {
    
    const [messageData, setMessageData] = useState(null); 
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        const fetchMessage = async () => {
            try {
                const data = await getDailyMessage();
                setMessageData(data); 
            } catch (error) {
                console.error("Error fetching daily message:", error);
                setIsError(true);
            } finally {
                setIsLoading(false);
            }
        };
        fetchMessage();
    }, []); 

    // ----------------------
    // ۱. مدیریت حالت Loading
    // ----------------------
    if (isLoading) {
        return (
             <div className="p-3 bg-gray-100 text-gray-500 rounded-xl text-[11px] text-center flex items-center justify-center rtl">
                 <Loader2 className="w-4 h-4 ml-2 animate-spin" />
                 در حال بارگذاری پیام روزانه...
             </div>
        );
    }
    
    // ----------------------
    // ۲. مدیریت حالت Error
    // ----------------------
    if (isError) {
        return (
            <div className="p-4 bg-red-100 border-r-4 border-red-500 text-red-700 rounded-xl text-[11px] text-justify flex items-center rtl text-right">
                <AlertTriangle className="w-4 h-4 ml-2 flex-shrink-0" />
                <span className="font-medium">خطا در واکشی پیام روزانه.</span> لطفاً بعداً تلاش کنید.
            </div>
        );
    }

    // ✅ اصلاح: book_slug اضافه شد
    const { title, message, product_slug, book_slug, link_text } = messageData || {};

    // ✅ اصلاح: book_slug به شرط اضافه شد تا از ناپدید شدن کامپوننت جلوگیری شود
    // اگر هیچ محتوایی وجود نداشت، رندر نکن
    if (!title && !message && !product_slug && !book_slug) {
        return null;
    }
    
    // ----------------------
    // ۴. رندرینگ نهایی بنر
    // ----------------------
    return (
        <div 
            className="p-4 bg-white border border-gray-200 rounded-xl shadow-sm rtl text-right" 
            role="alert"
        >
            {/* نمایش تاریخ روز شمسی (در سمت راست) */}
            <div className="flex justify-end items-center mb-3 text-[11px] font-medium text-gray-500 border-b border-gray-100 pb-2">
                <span className="text-sky-400 font-extrabold text-[11px]">{getPersianDate()}</span>
            </div>

            <div className="flex flex-col">
                
                {/* نمایش تیتر/عنوان پیام */}
                <div className="flex items-center mb-2">
                    <MessageSquare className="w-5 h-5 ml-2 text-purple-700 flex-shrink-0" />
                    {title && <p className="font-bold text-[12px] text-gray-800">{title}</p>} 
                </div>
                
                {/* پیام با قابلیت اسکرول */}
                {message && (
                    <p 
                        className="text-[11px] text-justify text-gray-700 leading-relaxed mb-4 max-h-64 overflow-y-auto"
                    >
                        {message}
                    </p>
                )}
                
                {/* ✅ اصلاح: منطق رندرینگ لینک (اول محصول، بعد کتاب) */}
                
                {/* ۱. اگر لینک محصول (درسگفتار) وجود داشت */}
                {link_text && product_slug && (
                    <Link 
                        to={`/products/${product_slug}`} 
                        className="mt-3 text-xs font-semibold text-purple-700 hover:text-purple-900 transition self-start"
                    >
                        {link_text} &larr;
                    </Link>
                )}
                
                {/* ۲. اگر لینک کتاب وجود داشت (و محصول نبود) */}
                {link_text && book_slug && !product_slug && (
                    <Link 
                        to={`/books/${book_slug}`} // (مسیر فرضی برای کتاب‌ها)
                        className="mt-3 text-xs font-semibold text-purple-700 hover:text-purple-900 transition self-start"
                    >
                        {link_text} &larr;
                    </Link>
                )}
                
            </div>
        </div>
    );
}